const capitalize = text => text.replace(/^\w/, (c) => c.toUpperCase());

export { capitalize };